module.exports = __webpack_public_path__ + "static/media/backgroundGround.4ce9e790.png";